import { API_ENDPOINT, AI_ENDPOINT } from '@Env/variables';
import { createAxiosInstance } from './axios';
import {
  AhaFeature,
  GenerateBody,
  GeneratedHistory,
  LinkObject,
  PushHistory,
  RevisionHistory,
  TestCases,
  TestRail,
  //JiraIssue,
} from '@Models/types';

export const aiGenerateAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, AI_ENDPOINT);

  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reGenerate: async (body: any) => {
      const res = await axios.post('/api/reGenerateCasesAsync', {
        ...body,
      });
      return res.data;
    },

    generate: async (body: GenerateBody) => {
      const res = await axios.post('/api/generateCasesAsync', {
        ...body,
      });
      return res.data;
    },

    generateAhaTicket: async (prompt: string) => {
      const res = await axios.post('/api/generateAhaTicket', {
        prompt,
      });
      return res.data;
    },

    publishAhaTicket: async (feature: AhaFeature, release_id: string) => {
      const res = await axios.post('/api/publishAhaTicket', {
        feature,
        release_id,
      });
      return res.data;
    },
  };
};

export let link_results: LinkObject[] = [];

export const clearLinks = () => {
  link_results = [];
};

export const getTestCaseCount = (tc: TestCases[] | undefined): number => {
  if (!Array.isArray(tc)) {
    return 0;
  }

  let ctr = 0;
  tc.forEach((item: TestCases) => {
    if (Array.isArray(item.GeneratedTestCase)) {
      ctr += item.GeneratedTestCase.length;
    }
  });

  return ctr;
};

export const testCasesAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, API_ENDPOINT);
  return {
    getStatus: async (id: string) => {
      const res = await axios.get<GeneratedHistory>(
        `/api/getGenerationStatus?id=${id}`
      );
      return res.data;
    },

    getPushStatus: async (id: string) => {
      const res = await axios.get<PushHistory>(`/api/getPushStatus?id=${id}`);
      return res.data;
    },

    getGenerationHistory: async () => {
      const res = await axios.get<GeneratedHistory[]>(
        `/api/getGenerationHistory`
      );
      return res.data;
    },

    getPushHistory: async () => {
      const res = await axios.get<PushHistory[]>('/api/getPushHistory');
      return res.data;
    },

    getTestCase: async (id: string) => {
      const res = await axios.get<GeneratedHistory>(
        `/api/getGenerationStatus?id=${id}`
      );
      return res.data;
    },

    pushToTestRail: async (input: TestRail) => {
      link_results = [];
      const res = await axios.post('/api/pushCases', {
        ...input,
      });
      link_results = link_results.concat(res.data);
      return true;
    },

    pushToTestRailAsync: async (input: TestRail) => {
      const res = await axios.post('/api/pushCasesAsync', {
        ...input,
      });
      return res.data;
    },

    fetchRevisionHistory: async (historyId: string) => {
      const res = await axios.get<RevisionHistory>(
        `/api/getRevisionHistory?id=${historyId}`
      );
      return res.data;
    },
  };
};
